import { ScaleAnswerTypeDto } from '@/api/generated';

import type { QuizQuestionsTranslations } from './quizQuestions.translation.pl.ts';

export const quizQuestionsTranslations: QuizQuestionsTranslations = {
  scaleQuestions: {
    scale3: {
      [ScaleAnswerTypeDto.Left]: 'A',
      [ScaleAnswerTypeDto.Center]: 'B',
      [ScaleAnswerTypeDto.Right]: 'C',
    },
    scale2: {
      [ScaleAnswerTypeDto.Left]: 'A',
      [ScaleAnswerTypeDto.Right]: 'B',
      [ScaleAnswerTypeDto.Center]: '',
    },
  },
  buttons: {
    next: 'Next',
    skip: 'Skip',
  },
  energyTable: {
    energyConsumption: 'Average monthly energy consumption (kWh)',
    office: 'Office',
    renewableSources: 'Renewable energy sources (%)',
    warsaw: 'Warsaw',
  },
  questions: {
    1: {
      titles: {
        1: 'Oh… and here there is almost too much going on.',
      },
      content: {
        1: "Everyone wants to join the latest interplanetary mission to Mars. You know… the prestige, an incredibly interesting project, and those views… A dream! There aren't many places, and there's never a shortage of volunteers. ",
        2: 'Every mission requires interdisciplinary skills, and the team must include a representative of every Orange department.',
        3: 'For example: in the interplanetary communications department we have two candidates for one place.',
        4: 'What should we do about it? Will you help me? How can we resolve this situation - prevent conflicts and strengthen cooperation at the same time?',
      },
    },
    2: {
      titles: {
        1: "Great! The first task is behind you! It wasn't that hard and you managed without the help of AI.",
      },
      content: {
        1: "And speaking of artificial intelligence, already in your times there was a lot of talk about responsibility and the ethical aspects of AI development. It's just as important now.",
        2: "Oh! I've just remembered I have something important to do here! I got an invitation to test a pilot version of a new AI-powered tool that everyone in our organization will soon be using. It will be an important change for the company, because it will let us communicate as holograms and improve collaboration between teams. If I decide to take part in the pilot, I have to find time for the initial training, the testing and giving feedback to the implementation team. And there are only so many hours in a day...",
      },
    },
    3: {
      titles: {
        1: "Thanks for the advice! I'll do that!",
        2: 'We value directness and - just like the people at Orange - we call each other by our first names, human ones.',
        3: "But jokes aside. There's something you need to help me with. You can do it, right?",
      },
      content: {
        1: 'As a thank-you, I have a joke for you.',
        2: `Two robots meet in the office kitchen. <br/> One of them says: <br/> - Hi, I'm Model-TRX-4987-Quantum-Unit-Alpha.<br/> - Oh, wow! – the other one replies - Can I call you something else?<br/> - Sure, just call me Chris.`,
        3: "There's a problem in one of the teams. Some robots are doing a great job ;) Others often freeze - not literally, but figuratively - and their work isn't as efficient anymore. First conversations with the team showed that something is off with motivation, but it's not clear exactly what. How can we solve this situation?",
      },
    },
    4: {
      titles: {
        1: "Now that's an idea! OK, time to get back to Earth.",
      },
      content: {
        1: "There's a lot of work waiting for us there. The portal will open in a moment. How ironic - having to wait for time travel. Oh well, what can you do - sign of the… times. Haha!",
        2: 'In your era, work looked a bit different, right? Lots of writing by hand, analyzing, searching... Phew, exhausting. </br> But at Orange you already had something back then that was a real revolution. Something my digital ancestors would call a “game changer”. I mean Dinootoo. It was not an ordinary program, but a powerful generative artificial intelligence platform available to every employee!',
        3: "I knew you had a nose for technology! Dinootoo was Orange's own tool - a secure gateway to the knowledge of those times. </br>It gave access to more than a dozen LLMs known all over the world, such as ChatGPT or Gemini, but in a secure, corporate environment. Imagine: you have one assistant that combines the knowledge and capabilities of all of them. You can talk to it, ask questions or upload files so that it instantly pulls out what matters most.</br>But that's just the tip of the iceberg. Do you want to know what exactly Dinootoo took off employees' plates every day?",
        4: 'Well, listen, because this sounds like magic, and in your times it was everyday life! Dinootoo was a master of tedious work. Need to write a difficult email in line with plain language rules? Dinootoo does it in a few seconds. Need a summary of a long report or notes from a meeting? Poof - done. Or maybe practicing feedback, structuring a presentation, generating images or even help with writing code? For Dinootoo, it was a piece of cake. Thanks to this, people got back time for what matters most at work - creativity and growth - instead of drowning in routine. But you had one more super-advanced feature there that let you “clone” helpers. Do you want to hear about this cherry on top?',
        5: 'That superpower was the ability to create your own assistants. In Dinootoo, anyone could build a dedicated helper, programmed to support very specific tasks, and then... share it with others on the team! It is like creating an expert in one field who works for everyone 24/7. It was tools like this that made work at Orange lighter, more efficient and simply... more fun. You used AI to have more room for being human.',
        6: "Lovely, but enough of these nostalgic trips. The portal is active! Let's jump in!",
      },
    },
    5: {
      titles: {
        1: "Oh, I see we've stumbled upon the legendary Orange Warsaw Festival on the way. Shall we do a robo dance?",
      },
      content: {
        1: 'Did you know that the music industry also uses cutting-edge technologies? Thanks to them, we can experience cultural events even more intensely. Just think of Augmented Reality, which the 5G network is perfect for.',
        2: "Right now the organizers are wondering what to call a new technology that will be used at the festival for the first time this year. This technology will let you feel the music with your whole body! It's going to be awesome! Only... what could we call it?",
      },
    },
    6: {
      titles: {
        1: "Good! Let's leave the concerts to the stars, we're heading to the office.",
      },
      content: {
        1: 'Uh-oh, you can feel the tension here. It looks like someone has just made an inappropriate joke.',
      },
    },
    7: {
      titles: {
        1: "Great! It's good to have a competent human on your team.",
      },
      content: {
        1: 'And speaking of competences, tell me, how do people think about them in your times?',
      },
    },
    8: {
      titles: {
        1: 'Do you hear that? Is that the sound of a concert?',
      },
      content: {
        1: 'Actually, it seems to be the voices of the Orange Warsaw Festival organizers. There are only two days left and still so much to do. Will you help them set priorities?',
      },
    },
    9: {
      titles: {
        1: "And everything's in tune! Let's go for a walk.",
      },
      content: {
        1: 'Did you know that the work of Emilia and her team made a beautiful forest grow here? It contributed to another company goal - net zero emissions.',
        2: "Planting forests isn't the only thing Orange does to take care of the environment.",
      },
    },
    10: {
      titles: {
        1: 'It was a tough decision, but your suggestion turned out to be very helpful. Thanks!',
      },
      content: {
        1: "But Emilia has one more dilemma - she's about to start a meeting with her team and has to tell them the next plan of action. She knows it's a good decision, but at the same time she feels quite stressed, because it will surely be a difficult moment for them.\nHow can she deal with it?",
      },
    },
    11: {
      titles: {
        1: 'It got heated, but we made it! The meeting is starting. Maciek, our colleague, will now present the results of our efforts so far.',
      },
      content: {
        1: 'Oops! He got lost interpreting the data, and now it needs to be fixed. Will you help?',
        2: `During his presentation, Maciek said: "Yesterday we ran a survey among our most loyal customers, asking whether they agree that our actions have a significant impact on solving the problem of climate change. Of the 15 people who took part in the survey, as many as 12 confirmed our hypothesis. I think that on this basis we can announce a big success of this initiative!".`,
      },
    },
    12: {
      titles: {
        1: "We've dealt with the corrections in Maciek's presentation. Now it's time for the finale!",
      },
      content: {
        1: 'One of the actions we take as part of our net zero goal is reducing the amount of energy from non-renewable sources used in our offices. ',
      },
    },
    13: {
      titles: {
        1: "Great! And we've reached the very end of the challenge!",
        2: 'Oh? Could it be? Yes! It works!',
      },
      content: {
        1: "That's almost all the tasks I've prepared for you. Time to go back, the portal is already waiting for us.",
        2: 'My cyber values compass is working properly now! All thanks to seeing how you act and make decisions.',
        3: 'Now I can clearly see that mindfulness means acting for customers, collaboration and respect. Responsibility means seeing things through, transparent communication and caring for our planet, and courage means looking for new solutions.',
        4: "Now it's time for your bold step towards the future. I hope you'll soon get the chance to join our internships. ",
        5: 'Finally, please fill in a short form.',
        6: 'I have to run now. It was really nice to meet you and I hope… see you soon! Bye!',
      },
    },
  },
};
